import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { ChevronDown, ListChecks, X } from "lucide-react";

export default function DataBulkToolbar({
  selectedCount = 0,
  onClear,
  actions = [],
  disabled = false,
}) {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef(null);
  const menuRef = useRef(null);
  const [pos, setPos] = useState({ top: 0, left: 0, width: 0 });

  useEffect(() => {
    if (!open) return undefined;

    const box = triggerRef.current?.getBoundingClientRect();
    if (box) {
      setPos({ top: box.bottom + 8, left: box.left, width: Math.max(box.width, 196) });
    }

    const onDoc = (event) => {
      if (triggerRef.current?.contains(event.target) || menuRef.current?.contains(event.target)) {
        return;
      }
      setOpen(false);
    };

    window.addEventListener("mousedown", onDoc);
    return () => window.removeEventListener("mousedown", onDoc);
  }, [open]);

  useEffect(() => {
    if (!selectedCount) setOpen(false);
  }, [selectedCount]);

  if (!selectedCount) return null;

  return (
    <>
      <span className="data-selection-count">{selectedCount} selected</span>

      <div className="data-bulk-wrap">
        <button
          ref={triggerRef}
          type="button"
          className={`data-bulk-trigger${open ? " is-open" : ""}`}
          disabled={disabled}
          onClick={() => setOpen((prev) => !prev)}
        >
          <ListChecks size={16} />
          Bulk actions
          <ChevronDown size={16} />
        </button>

        {open
          ? createPortal(
              <div
                ref={menuRef}
                className="data-bulk-menu"
                style={{ top: pos.top, left: pos.left, width: pos.width }}
              >
                {actions.map((action) => (
                  <button
                    key={action.key}
                    type="button"
                    className={`data-bulk-option${action.tone === "danger" ? " is-danger" : ""}`}
                    disabled={disabled}
                    onClick={() => {
                      setOpen(false);
                      action.onClick?.();
                    }}
                  >
                    {action.label}
                  </button>
                ))}
              </div>,
              document.body
            )
          : null}
      </div>

      <button
        type="button"
        className="data-selection-clear"
        aria-label="Clear selection"
        disabled={disabled}
        onClick={onClear}
      >
        <X size={14} />
      </button>
    </>
  );
}
